import { base_url } from "./utils/axiosConfig"; // make sure this path is correct

export const registerPush = async (email,mobile, publicVapidKey) => {
  try {
    if (!email) {
      console.log("No email provided for push registration");
      return;
    }

    if (!("serviceWorker" in navigator)) {
      console.log("Service workers not supported");
      return;
    }

    // 1️⃣ Ask notification permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission denied");
      return;
    }

    // 2️⃣ Register SW and wait for ready
    await navigator.serviceWorker.register("/sw.js");
    console.log("SW registered, waiting...");

    const serviceWorker = await navigator.serviceWorker.ready;
    console.log("SW Ready:", serviceWorker);

    // 3️⃣ Convert VAPID key
    const urlBase64ToUint8Array = (base64String) => {
      const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
      const base64 = (base64String + padding)
        .replace(/-/g, "+")
        .replace(/_/g, "/");
      const rawData = atob(base64);
      return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
    };

    // 4️⃣ Subscribe
    const subscription = await serviceWorker.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
    });

    console.log("Push subscribed:", subscription);

    // 5️⃣ Save to backend (email only)
    const res = await fetch(`${base_url}user/push-subscribe`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email,mobile, subscription }),
    });

    const data = await res.json();
    console.log("Save response:", data);

    return true;
  } catch (error) {
    console.error("Push subscription error:", error);
    return false;
  }
};
